import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";
import { useExpenseStore } from "../store";

export const updateRequisition = ({
  churchId,
  requisitionData,
  requisitionId
}) => {
  return axios.post(
    `/churches/${churchId}/requisitions/${requisitionId}?_method=PATCH`,
    requisitionData
  );
};

export const useUpdateRequisition = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeCreateRequisitionModal = useExpenseStore(
    state => state.closeCreateRequisitionModal
  );
  const navigate = useNavigate();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["requisitions"]);
      queryClient.invalidateQueries(["requisitions-paginated"]);
      queryClient.invalidateQueries(["requisition"]);

      setNotification({
        type: "success",
        message: "Requisition updated successfully!"
      });

      closeCreateRequisitionModal();

      navigate("/finances/temp/expense/requisition");
    },
    ...config,
    mutationFn: updateRequisition
  });
};
